import { render, staticRenderFns } from "./launch.vue?vue&type=template&id=136e970b&scoped=true&"
import script from "./launch.vue?vue&type=script&lang=ts&"
export * from "./launch.vue?vue&type=script&lang=ts&"
import style0 from "./launch.vue?vue&type=style&index=0&id=136e970b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136e970b",
  null
  
)

export default component.exports